import { useRef } from 'react';
import {
  Flex,
  // TODO: Label should not be used directly and should stay as an internal utility for bricks form components. Please update the usage of Label.
  // eslint-disable-next-line no-restricted-imports
  Label,
  Text,
} from '@opendoor/bricks/core';
import { SellerFlowAddressInputProps } from 'components/shared/SellerFlowAddressInput';
import { useInViewAfterLoad } from 'components/shared/hooks/useInView';
import { DynamicComponentWithCondition } from 'components/shared/dynamic';
import { Illustration } from '@opendoor/cinderblocks/platform/Illustration';

const CrossSell = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { inView: inViewCrossSell } = useInViewAfterLoad({
    triggerOnce: true,
    initialInView: false,
    ref,
  });
  return (
    <Flex
      justifyContent="space-between"
      backgroundColor="neutrals10"
      alignItems="center"
      py="6"
      px="8"
      borderRadius="roundedSquare"
      gridGap="12px"
      my="3"
      ref={ref}
    >
      <Flex flexDirection="column">
        <Flex justifyContent="flex-start" alignItems="center" gridGap="12px" mb="5">
          <Flex flexShrink={0} order={[2, 2, 1, 1]} width="36px" height="36px">
            <Illustration type="spot" illustrationName="Envelope-Contract" />
          </Flex>
          <Text
            as="h2"
            m="0"
            fontSize={['s2', 's2', 's3', 's3']}
            fontWeight="bold"
            order={[1, 1, 2, 2]}
          >
            Also selling? We can help you buy and sell in one go.
          </Text>
        </Flex>
        <Text fontSize={['s0', 's0', 's1', 's1']} mb="3">
          Buy with Opendoor, skip stressful showing, and move once.
        </Text>
        <Label
          id="address-input-label"
          display="inline-block"
          mb="4"
          fontWeight="semibold"
          color="neutrals90"
          fontSize="s0"
          mt="4"
          htmlFor="address-input"
        >
          Enter your home address
        </Label>
        <DynamicComponentWithCondition<SellerFlowAddressInputProps>
          loadingCondition={inViewCrossSell}
          dynamicLoaderFunction={() =>
            import('components/shared/SellerFlowAddressInput').then(
              (mod) => mod.SellerFlowAddressInput,
            )
          }
          hideLabel
          analyticsName="cosmos-pdp-address-input"
          channel="DEFAULT"
          inputLocation="pdp-cross-sell-cta"
          // it's set to false
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={false}
          placeholderText="Your address"
          showCta
          ctaProps={{
            actionText: 'Get my free offer',
            'aria-label': 'Get my free offer',
          }}
          product="OPENDOOR_COMPLETE"
        />
      </Flex>
    </Flex>
  );
};

export default CrossSell;
